import { skipToken } from '@apollo/client/react'
import type { FC } from 'react'
import IcBaselineChatBubbleOutline from '~icons/ic/baseline-chat-bubble-outline'
import IcBaselineFavoriteBorder from '~icons/ic/baseline-favorite-border'
import { useGetArtwork } from 'src/services/apollo/artwork'
import type { Artwork } from 'src/services/apollo/generated/graphql'
import { formatNum } from 'src/utils/formatNum'

const ArtworkStatistics: FC<{
  artwork?: Artwork
  artworkId?: string
  showLikedCount?: boolean
  showCommentCount?: boolean
}> = ({
  artwork: _artwork,
  showLikedCount = true,
  showCommentCount = true,
  artworkId,
}) => {
  const { data: artwork = _artwork } = useGetArtwork(artworkId ?? skipToken)

  return (
    <>
      {showLikedCount && artwork?.likedCount != null && (
        <div className="flex gap-1">
          <IcBaselineFavoriteBorder className="text-icon size-5" />
          <span className="tabular-nums">{formatNum(artwork?.likedCount)}</span>
        </div>
      )}
      {showCommentCount && artwork?.commentCount != null && (
        <div className="flex gap-1">
          <IcBaselineChatBubbleOutline className="text-icon size-5" />
          <span className="tabular-nums">
            {formatNum(artwork.commentCount)}
          </span>
        </div>
      )}
    </>
  )
}

export default ArtworkStatistics
